/**
 * État et chargement d'une liste paginée côté serveur (15/10/2026). Usage dans un composant :
 *
 *   data() { return { analyses: nouvelleListe() } }
 *   charger() { return chargerPage(this.analyses, params => api.tarifAnalyses(this.assur_id, params)) }
 *   <input v-model="analyses.q" @input="rechercherDiffere(analyses, charger)">
 *   <b-table :items="analyses.lignes" :busy="analyses.chargement">        (ni :per-page ni :filter : le serveur s'en charge)
 *   <b-pagination v-model="analyses.page" :total-rows="analyses.total" :per-page="analyses.per_page" @input="charger()">
 *
 * Une réponse arrivée après une plus récente (pages changées vite, recherche) est ignorée.
 */
export const PAR_PAGE = 20

export function nouvelleListe(per_page = PAR_PAGE) {
    return {
        lignes: [],
        page: 1,
        per_page: per_page,
        total: 0,
        q: '',
        chargement: false,
        erreur: false,
        sequence: 0,
        minuteur: null
    }
}

/**
 * Charge la page courante. `appel(params)` reçoit { page, per_page, q } (à compléter si besoin) et renvoie la réponse
 * paginée { data, total, current_page, ... }.
 */
export function chargerPage(liste, appel) {
    liste.sequence++
    const sequence = liste.sequence
    liste.chargement = true
    liste.erreur = false

    return appel({ page: liste.page, per_page: liste.per_page, q: liste.q }).then((reponse) => {
        if (sequence !== liste.sequence) {
            return
        }
        liste.lignes = (reponse && reponse.data) ? reponse.data : []
        liste.total = (reponse && reponse.total) ? reponse.total : 0
        if (reponse && reponse.current_page) {
            liste.page = reponse.current_page
        }
    }).catch(() => {
        // L'écran affiche l'erreur à partir de liste.erreur (pas de promesse rejetée à gérer par l'appelant)
        if (sequence === liste.sequence) {
            liste.erreur = true
        }
    }).finally(() => {
        if (sequence === liste.sequence) {
            liste.chargement = false
        }
    })
}

/**
 * Recherche : attend la fin de la saisie, revient à la page 1 et recharge
 */
export function rechercherDiffere(liste, charger, delai = 350) {
    clearTimeout(liste.minuteur)
    liste.minuteur = setTimeout(() => {
        liste.page = 1
        charger()
    }, delai)
}

/**
 * Retour à la première page puis rechargement (changement d'assurance, de filtre…)
 */
export function rechargerDepuisDebut(liste, charger) {
    liste.page = 1
    return charger()
}
